module.exports = __webpack_public_path__ + "static/media/edit.4a58c050.svg";